/* ============================================================
   KICK SPEED SIZE FINDER – CORE (logic)
   File: assets/ks-finder-core.js
   Loaded by snippets/ks-finder-core.liquid, which first writes the
   shop's data into window.__KS_CFG__ (charts from
   snippets/ks-chart-data.liquid, brand charts, theme settings).
   A normal (not deferred) script on purpose: everything that renders
   the snippet expects window.KSFinder to exist right after it, exactly
   as when this code was inline. Being a file, the browser keeps it in
   its cache, so it is downloaded once instead of with every page (and
   up to three times on the home page).
   Runs once per page; later copies of the tag stop at the first line.
   ============================================================ */
(function () {
  if (window.KSFinder) { delete window.__KS_RAW__; return; }

  /* Everything that comes from the shop (the chart numbers, the brand
     charts, the theme settings) is written by snippets/ks-finder-core.liquid
     into window.__KS_CFG__ just before this file is loaded. */
  var CFG = window.__KS_CFG__ || {}, CFGT = CFG.t || {};
 
  /* ---------- Charts, parsed from the single Liquid definition ---------- */
  var CHARTS = {}, CAPTIONS = {};
  String(CFG.charts || '').split('~').forEach(function (block) {
    var parts = block.split('|');
    CAPTIONS[parts[0]] = parts[1];
    /* row = [US size, inner length cm, EU size] */
    CHARTS[parts[0]] = parts[2].split(';').map(function (row) {
      var c = row.split(':');
      return [parseFloat(c[0]), parseFloat(c[1]), parseInt(c[2], 10)];
    });
  });
 
  var BY_RUN = {};
  Object.keys(CHARTS).forEach(function (k) {
    BY_RUN[CHARTS[k].map(function (r) { return r[0]; })
      .sort(function (a, b) { return a - b; }).join('|')] = k;
  });
 
  /* ---------- Brand size conversion ----------
     A brand's size chart says which foot length each of its sizes is
     built for. Read backwards, that turns "I wear Nike 9" into an
     estimate of the foot. An estimate, not a measurement: the customer
     may not even be wearing the right size in that brand. Every screen
     that uses this says so, and shows the centimetres it came up with
     so the number can be corrected by hand.                            */
  var BRANDS = [];
  String(CFG.brands || '').split('~').forEach(function (block) {
    var p = block.split('|');
    BRANDS.push({
      brand:      p[0],
      name:       p[1],
      gender:     p[2],
      genderName: p[3],
      sizes: p[4].split(';').map(function (row) {
        var c = row.split(':');
        /* eu stays a string: adidas prints "42 2/3", not a number */
        return { label: c[0], cm: parseFloat(c[1]), eu: c[2] || '' };
      })
    });
  });
 
  /* Grouped for a two step picker: brand first, then which of its
     charts. A brand only offers the charts it actually publishes. */
  function brandList() {
    var out = [], seen = {};
    BRANDS.forEach(function (g) {
      if (!seen[g.brand]) {
        seen[g.brand] = { brand: g.brand, name: g.name, genders: [] };
        out.push(seen[g.brand]);
      }
      seen[g.brand].genders.push({ key: g.gender, name: g.genderName, sizes: g.sizes });
    });
    return out;
  }
 
  function brandSizes(brand, gender) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i].brand === brand && BRANDS[i].gender === gender) return BRANDS[i].sizes;
    }
    return [];
  }
 
  /* Returns the published foot length in cm, or null if that brand does
     not publish that size. Never guesses between two rows. */
  function brandToCm(brand, gender, label) {
    var rows = brandSizes(brand, gender);
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].label === String(label)) return rows[i].cm;
    }
    return null;
  }
 
  /* One system at a time: "US 9.5" or "EU 43 1/3". Showing both on
     every row made the dropdown a wall of numbers, so the sections
     carry a US/EU switch and ask for the side the customer thinks in.
     Falls back to US if the brand publishes no EU for that size. */
  function brandSizeLabel(size, system) {
    if (system === 'eu' && size.eu) return 'EU ' + size.eu;
    return 'US ' + size.label;
  }
 
  function brandEu(brand, gender, label) {
    var rows = brandSizes(brand, gender);
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].label === String(label)) return rows[i].eu || '';
    }
    return '';
  }
 
  function brandName(brand) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i].brand === brand) return BRANDS[i].name;
    }
    return brand;
  }
 
  function genderName(brand, gender) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i].brand === brand && BRANDS[i].gender === gender) return BRANDS[i].genderName;
    }
    return '';
  }
 
  /* ---------- Fit targets ----------
     Snug and Comfort are the numbers published on /pages/size-guide:
       "Snug fit: internal length approximately 0.5 cm longer than your foot"
       "Comfort fit: internal length 0.5-1 cm longer than your foot"
     Room to grow is an addition for children's feet.                       */
  var FITS = {
    snug:    { label: 'Snug',         target: 0.5, note: 'Close and secure' },
    comfort: { label: 'Comfort',      target: 1.0, note: 'Everyday fit' },
    grow:    { label: 'Room to grow', target: 1.5, note: 'Foot still growing' }
  };
 
  /* Never recommend below the floor the size guide already publishes:
     "shoes that are 0.2 - 0.38 inch (0.5-1cm) bigger than your measured foot".
     A foot that cannot get 0.5 cm in any model is told so, rather than
     being sold something tight. */
  var MIN_ROOM = 0.5;   /* below this we do not recommend at all         */
  var MAX_ROOM = 2.0;   /* above this the foot moves inside the shoe     */
  var SOCK_CM  = 0.2;   /* allowance for thick socks                     */
 
  function num(v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')); }
  function r2(n)  { return Math.round(n * 100) / 100; }
 
  /* Colour names as typed in the admin are not always consistent:
     "Black and White" and "White and Black" are the same thing, and
     Violet is only used once where Purple is used elsewhere. Fold those
     together so the filter shows one chip per real colour. */
  function normColor(v) {
    var s = String(v).trim().toLowerCase();
    if (s === 'violet') s = 'purple';
    var parts = s.split(' and ').map(function (x) { return x.trim(); }).sort();
    return parts.map(function (word) {
      return word.replace(/\b\w/g, function (m) { return m.toUpperCase(); });
    }).join(' and ');
  }
 
  /* ---------- Catalog ---------- */
  var RAW = window.__KS_RAW__ || [];
  delete window.__KS_RAW__;
 
  /* One raw product in, one matched product out (or null when its sizes
     match no chart). Exposed as KSFinder.build so the product page can
     match its own product without loading the whole catalog. */
  function build(p) {
    if (!p || !p.s || p.s.length < 3) return null;
    var run = p.s.map(num);
    if (run.some(isNaN)) return null;
 
    var forced = null;
    (p.g || []).forEach(function (t) {
      var m = /^ks-?chart-([A-G])$/i.exec(String(t).trim());
      if (m) forced = m[1].toUpperCase();
    });
 
    var id = forced || BY_RUN[run.slice().sort(function (a, b) { return a - b; }).join('|')];
    if (!id || !CHARTS[id]) return null;
 
    /* Normalise the in-stock list the same way the size run above was
       normalised. Without this a shop that stores "7.0" would fail the
       lookup for size 7 and every result would read as sold out. */
    var avail = '|';
    String(p.a || '').split('|').forEach(function (v) {
      var n = num(v);
      if (!isNaN(n)) avail += n + '|';
    });
 
    return {
      title:  p.t,
      url:    p.u,
      img:    p.i || '',
      chart:  id,
      rows:   CHARTS[id],
      avail:  avail,
      colors: (p.c || []).map(normColor),
      system: /heel\s*wheels?/i.test(p.t) ? 'heel' : 'popout',
      led:    /\bled\b/i.test(p.t),
      height: /\bMID\b/.test(p.t) ? 'mid' : 'low'
    };
  }
 
  var PRODUCTS = [];
  RAW.forEach(function (p) {
    var built = build(p);
    if (built) PRODUCTS.push(built);
  });
 
  /* Every colour in the catalog, most used first — the filter builds
     its chips from this, so it stays correct as products change. */
  function colorList() {
    var count = {};
    PRODUCTS.forEach(function (p) {
      p.colors.forEach(function (c) { count[c] = (count[c] || 0) + 1; });
    });
    return Object.keys(count).sort(function (a, b) {
      return count[b] - count[a] || a.localeCompare(b);
    });
  }
 
  /* ---------- Recommendation ---------- */
 
  function score(room, target) {
    return Math.max(0, Math.round(100 - Math.abs(room - target) * 50));
  }
 
  /* opts: { fit: 'comfort', socks: false } */
  function sizeFor(product, foot, opts) {
    opts = opts || {};
    var target = (FITS[opts.fit] || FITS.comfort).target;
    var effective = foot + (opts.socks ? SOCK_CM : 0);
 
    var cands = [];
    product.rows.forEach(function (r) {
      var room = r2(r[1] - effective);
      if (room < MIN_ROOM || room > MAX_ROOM) return;
      cands.push({
        us: r[0],
        cm: r[1],
        eu: r[2],
        room: room,
        score: score(room, target),
        inStock: product.avail.indexOf('|' + r[0] + '|') > -1
      });
    });
    if (!cands.length) return null;
 
    /* Best score first. On a tie take the LARGER size, because the size
       guide says: "When caught between two sizes, erring on the side of
       the slightly larger option often yields the best outcome."        */
    var ranked = cands.slice().sort(function (a, b) {
      return b.score - a.score || b.room - a.room;
    });
 
    var inStock = ranked.filter(function (c) { return c.inStock; });
    var best = inStock[0] || null;
    var pick = best || ranked[0];
 
    /* Neighbours of the chosen size, so we can be honest that a home
       measurement is not precise to the millimetre. */
    var bySize = cands.slice().sort(function (a, b) { return a.us - b.us; });
    var i = bySize.map(function (c) { return c.us; }).indexOf(pick.us);
 
    return {
      best:    best,
      bestAny: ranked[0],
      all:     bySize,
      up:      i > -1 ? bySize[i + 1] || null : null,
      down:    i > 0  ? bySize[i - 1] || null : null,
      target:  target
    };
  }
 
  function findAll(foot, opts, filters) {
    filters = filters || {};
    var out = [];
 
    PRODUCTS.forEach(function (p) {
      if (filters.system && p.system !== filters.system) return;
      if (filters.led === true  && !p.led) return;
      if (filters.led === false &&  p.led) return;
      if (filters.height && p.height !== filters.height) return;
      if (filters.color && p.colors.indexOf(filters.color) < 0) return;
 
      var r = sizeFor(p, foot, opts);
      if (!r) return;
 
      out.push({
        product: p,
        pick:    r.best || r.bestAny,
        detail:  r,
        soldOut: !r.best,
        score:   (r.best || r.bestAny).score
      });
    });
 
    out.sort(function (a, b) {
      if (a.soldOut !== b.soldOut) return a.soldOut ? 1 : -1;
      return b.score - a.score;
    });
    return out;
  }
 
  function coverage() {
    var lo = Infinity, hi = -Infinity;
    PRODUCTS.forEach(function (p) {
      p.rows.forEach(function (r) {
        if (r[1] < lo) lo = r[1];
        if (r[1] > hi) hi = r[1];
      });
    });
    return { minInner: lo, maxInner: hi, minFoot: lo - MAX_ROOM, maxFoot: hi - MIN_ROOM };
  }
 
  function toCm(value, unit) {
    var n = parseFloat(String(value).replace(',', '.'));
    if (isNaN(n)) return NaN;
    return unit === 'in' ? Math.round(n * 2.54 * 10) / 10 : n;
  }
 
  /* ---------- Remember what they typed ---------- */
  var STORE = 'ks_finder_v1';
  function remember(state) {
    try { localStorage.setItem(STORE, JSON.stringify(state)); } catch (e) {}
  }
  function recall() {
    try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; }
    catch (e) { return {}; }
  }
 
  /* ---------- Measurable ----------
     Every size tool reports what shoppers do through this one function,
     for example KSFinder.track('ks_finder_search', { foot_cm: 23.4 }).

     1. Always pushed to window.dataLayer (stays in the page).
     2. Sent to Google Analytics 4 only when Customize > Theme settings >
        Kick Speed: analytics is switched on AND the shopper's privacy
        choice allows analytics (Shopify Customer Privacy API,
        analyticsProcessingAllowed). Not sent inside the theme editor.

     Why the theme loads its own Google tag: the store's GA4 tag runs in
     the Google & YouTube app's web pixel, a sandbox the theme cannot
     reach, so there is no gtag() on the page. The theme therefore loads
     the Google tag for the same measurement ID, but only after the first
     size tool event and only with analytics allowed. It keeps its own
     data layer (ksDataLayer), sends no page views (the app does that),
     sends only events whose names start with ks_, each with send_to, and
     always denies ads storage and ads signals: these events are for
     analytics only. Same _ga cookie as the app, so the events land in the
     same visit as the app's add_to_cart and purchase.

     Before the shopper has chosen (cookie banner still open) events wait
     in memory on this page: sent if analytics is then allowed, dropped if
     it is declined. Once allowed, an event not yet handed to the Google
     tag is also kept in sessionStorage, so a click that leaves the page
     (a card, a link) is sent on the next page with its own page address.
     Never sent: names of saved people, email, anything typed as text.
     Add ?ks_debug=1 to a URL to see the events in GA4 > Admin > DebugView.
     KSFinder.analytics() tells the current state.                        */
  var GA = {
    on: CFG.gaOn === true,
    id: String(CFG.gaId || '').replace(/\s+/g, '').toUpperCase()
  };
  if (!/^G-[A-Z0-9]{4,20}$/.test(GA.id)) GA.on = false;
  try { if (window.Shopify && window.Shopify.designMode) GA.on = false; } catch (e) {}
  var GA_KEY = 'ks_ga_q', GA_MAX = 30, GA_AGE = 30 * 60 * 1000;
  /* state: idle (nothing asked yet) · ask (privacy API loading) ·
     wait (shopper has not chosen) · load (Google tag loading) · on · off */
  var ga = { state: 'idle', mem: [], debug: false, sent: 0, script: null, loaded: false, failed: false };
  var GA_TOOL = [
    ['ks_finder_', 'finder'], ['ks_helper_', 'helper'], ['ks_chart_', 'chart'],
    ['ks_dock_', 'dock'], ['ks_shop_size_', 'shop_by_size'], ['ks_guide_', 'size_guide'],
    ['ks_shop_my_size', 'my_sizes'], ['ks_mysizes_', 'my_sizes'], ['ks_sizes_', 'my_sizes'],
    ['ks_size_', 'my_sizes'], ['ks_cart_', 'cart'], ['ks_order_', 'cart'],
    ['ks_hero_', 'hero'], ['ks_popup_', 'popup'], ['ks_filter_', 'filters']
  ];
  try {
    if (/[?&]ks_debug=1(&|$)/.test(window.location.search)) sessionStorage.setItem('ks_ga_debug', '1');
    ga.debug = sessionStorage.getItem('ks_ga_debug') === '1';
  } catch (e) {}

  function gtagKS() { window.ksDataLayer.push(arguments); }

  function gaParams(name, data, page, title) {
    var out = {}, k, v, i;
    for (k in data) {
      if (!Object.prototype.hasOwnProperty.call(data, k) || k === 'event') continue;
      v = data[k];
      if (v === null || v === undefined || v === '') continue;
      if (typeof v === 'boolean') v = v ? 'yes' : 'no';
      else if (typeof v === 'number') { if (!isFinite(v)) continue; v = Math.round(v * 100) / 100; }
      else if (typeof v === 'string') v = v.slice(0, 100);
      else continue;
      out[String(k).slice(0, 40)] = v;
    }
    for (i = 0; i < GA_TOOL.length; i++) {
      if (name.indexOf(GA_TOOL[i][0]) === 0) { out.ks_tool = GA_TOOL[i][1]; break; }
    }
    if (page) out.page_location = String(page).slice(0, 1000);
    if (title) out.page_title = String(title).slice(0, 300);
    out.send_to = GA.id;
    return out;
  }

  function gaStore() {
    if (ga.state !== 'load') return;
    try {
      if (ga.mem.length) sessionStorage.setItem(GA_KEY, JSON.stringify(ga.mem));
      else sessionStorage.removeItem(GA_KEY);
    } catch (e) {}
  }
  function gaForget() { try { sessionStorage.removeItem(GA_KEY); } catch (e) {} }

  function gaFlush() {
    var list = ga.mem;
    ga.mem = [];
    gaForget();
    list.forEach(function (x) {
      if (Date.now() - x.t > GA_AGE) return;
      gtagKS('event', x.n, gaParams(x.n, x.d, x.p, x.h));
      ga.sent++;
    });
  }

  function gaLoad() {
    if (ga.state === 'load' || ga.state === 'on') return;
    if (ga.failed) { ga.state = 'off'; ga.mem = []; gaForget(); return; }
    ga.state = 'load';
    gaStore();
    if (ga.script) {
      /* allowed again after a "no" on this page */
      if (ga.loaded) {
        gtagKS('consent', 'update', { analytics_storage: 'granted' });
        ga.state = 'on';
        gaFlush();
      }
      return;
    }
    window.ksDataLayer = window.ksDataLayer || [];
    gtagKS('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    gtagKS('set', 'allow_google_signals', false);
    gtagKS('set', 'allow_ad_personalization_signals', false);
    gtagKS('js', new Date());
    /* debug_mode only in config: as an event parameter Google sends it
       as a plain parameter and DebugView never sees it (tested 4 Oct) */
    gtagKS('config', GA.id, ga.debug ? { send_page_view: false, debug_mode: true } : { send_page_view: false });
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA.id) + '&l=ksDataLayer';
    s.onload = function () {
      ga.loaded = true;
      if (ga.state !== 'load') return;
      ga.state = 'on';
      gaFlush();
    };
    s.onerror = function () {
      /* blocked (an ad blocker) or offline: stay quiet, keep nothing */
      ga.failed = true;
      ga.state = 'off';
      ga.mem = [];
      gaForget();
    };
    ga.script = s;
    (document.head || document.documentElement).appendChild(s);
  }

  /* what the shopper's privacy choice says right now:
     'yes' allowed · 'no' declined · 'wait' not chosen yet */
  function gaChoice() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null;
    try {
      if (cp.analyticsProcessingAllowed()) return 'yes';
      var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c && c.analytics === 'no' ? 'no' : 'wait';
    } catch (e) { return 'no'; }
  }

  function gaDecide() {
    var c = gaChoice();
    if (c === 'yes') { gaLoad(); return; }
    if (c === 'no') { ga.state = 'off'; ga.mem = []; gaForget(); return; }
    ga.state = 'wait';
  }

  function gaAsk() {
    if (!GA.on || ga.state !== 'idle') return;
    if (gaChoice() !== null) { gaDecide(); return; }
    var S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') { ga.state = 'off'; ga.mem = []; return; }
    ga.state = 'ask';
    try {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (ga.state !== 'ask') return;
        if (err || gaChoice() === null) { ga.state = 'off'; ga.mem = []; gaForget(); return; }
        gaDecide();
      });
    } catch (e) { ga.state = 'off'; ga.mem = []; }
  }

  /* the cookie banner answered, or the shopper changed their choice */
  document.addEventListener('visitorConsentCollected', function (e) {
    if (!GA.on) return;
    var ok = !!(e && e.detail && e.detail.analyticsAllowed);
    if (ok) {
      if (ga.state === 'on' || ga.state === 'load') return;
      if (ga.mem.length || ga.loaded) gaLoad();
      else ga.state = 'idle';
    } else {
      if (ga.loaded) gtagKS('consent', 'update', { analytics_storage: 'denied' });
      ga.state = 'off';
      ga.mem = [];
      gaForget();
    }
  });

  function gaTrack(name, data) {
    if (!GA.on || name.indexOf('ks_') !== 0) return;
    if (ga.state === 'off') return;
    var item = { n: name, d: data || {}, p: window.location.href, h: document.title, t: Date.now() };
    if (ga.state === 'on') { gtagKS('event', name, gaParams(name, item.d, item.p, item.h)); ga.sent++; return; }
    ga.mem.push(item);
    if (ga.mem.length > GA_MAX) ga.mem.shift();
    if (ga.state === 'load') gaStore();
    if (ga.state === 'idle') gaAsk();
  }

  /* events that were waiting when the last page was left */
  if (GA.on) {
    try {
      var gaOld = JSON.parse(sessionStorage.getItem(GA_KEY) || '[]');
      if (gaOld && gaOld.length) {
        ga.mem = gaOld.filter(function (x) { return x && x.n && Date.now() - x.t < GA_AGE; }).slice(-GA_MAX);
        if (ga.mem.length) gaAsk(); else gaForget();
      }
    } catch (e) { gaForget(); }
  }

  function track(name, data) {
    var payload = Object.assign({ event: name }, data || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try { gaTrack(String(name || ''), data || {}); } catch (e) {}
  }
  function analytics() {
    return { on: GA.on, id: GA.id, state: ga.state, waiting: ga.mem.length, sent: ga.sent, debug: ga.debug };
  }
 
  /* ---------- Saved sizes ----------
     A shopper can keep several foot lengths under a name ("Me", "Emma").
     They live in this browser's localStorage and nowhere else: nothing
     here sends them to the store, and names are never put in analytics.
     Switched on and off for the whole shop in
     Customize > Theme settings > Kick Speed: saved sizes.               */
  var SAVED = {
    on:     CFG.savedOn,
    max:    Math.min(10, Math.max(1, parseInt(CFG.savedMax, 10) || 6)),
    names:  String(CFG.savedNames || '').split(',').map(cleanName).filter(Boolean).slice(0, 8),
    remind: Math.max(0, parseInt(CFG.remind, 10) || 0),
    who:    CFG.remindWho,
    t: {
      saved:     CFGT.ks_t_saved,
      save:      CFGT.ks_t_save,
      save_btn:  CFGT.ks_t_save_btn,
      save_lab:  CFGT.ks_t_save_lab,
      need_name: CFGT.ks_t_need_name,
      cancel:    CFGT.ks_t_cancel,
      name:      CFGT.ks_t_name,
      private:   CFGT.ks_t_private,
      update:    CFGT.ks_t_update,
      save_new:  CFGT.ks_t_save_new,
      saved_ok:  CFGT.ks_t_saved_ok,
      remeasure: CFGT.ks_t_remeasure,
      measure_again: CFGT.ks_t_measure_again,
      full:      CFGT.ks_t_full,
      taken:     CFGT.ks_t_taken,
      edit:      CFGT.ks_t_edit,
      done:      CFGT.ks_t_done,
      del:       CFGT.ks_t_delete,
      del_ask:   CFGT.ks_t_delete_ask
    }
  };
  var SIZES = 'ks_sizes_v1', PICK = 'ks_sizes_pick';
 
  function cleanName(s) {
    return String(s == null ? '' : s).replace(/[<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 24);
  }
  function okFoot(n) { return typeof n === 'number' && isFinite(n) && n >= 10 && n <= 40; }
 
  function readSizes() {
    var list;
    try { list = JSON.parse(localStorage.getItem(SIZES) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) return [];
    var out = [];
    list.forEach(function (p) {
      if (!p || typeof p.id !== 'string' || !cleanName(p.name) || !okFoot(+p.foot)) return;
      out.push({
        id:    p.id,
        name:  cleanName(p.name),
        foot:  Math.round(+p.foot * 10) / 10,
        fit:   FITS[p.fit] ? p.fit : 'comfort',
        socks: !!p.socks,
        t:     +p.t || Date.now()
      });
    });
    return out;
  }
  function announce() {
    try { document.dispatchEvent(new CustomEvent('ks:sizes')); } catch (e) {}
  }
  function writeSizes(list) {
    try { localStorage.setItem(SIZES, JSON.stringify(list)); } catch (e) { return false; }
    announce();
    return true;
  }
  /* Another tab saved or deleted a size: tell this page too. */
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === SIZES) announce();
  });
 
  function getSize(id) {
    return readSizes().filter(function (p) { return p.id === id; })[0] || null;
  }
  function byName(name) {
    var n = cleanName(name).toLowerCase();
    return readSizes().filter(function (p) { return p.name.toLowerCase() === n; })[0] || null;
  }
  /* The saved size with exactly these numbers, if there is one. */
  function matchSize(foot, fit, socks) {
    var f = Math.round(+foot * 10) / 10;
    return readSizes().filter(function (p) {
      return p.foot === f && p.fit === (fit || 'comfort') && p.socks === !!socks;
    })[0] || null;
  }
 
  /* p: { id?, name, foot, fit, socks }
     With an id it updates that size. Without one it updates the size
     that already has this name, or adds a new one.
     Returns { item, updated } or { error: 'off'|'name'|'foot'|'taken'|'full'|'storage' } */
  function saveSize(p) {
    if (!SAVED.on) return { error: 'off' };
    p = p || {};
    var name = cleanName(p.name);
    var foot = Math.round(+p.foot * 10) / 10;
    if (!name) return { error: 'name' };
    if (!okFoot(foot)) return { error: 'foot' };
 
    var list = readSizes(), at = -1, clash = false;
    list.forEach(function (x, i) {
      var same = x.name.toLowerCase() === name.toLowerCase();
      if (p.id) {
        if (x.id === p.id) at = i;
        else if (same) clash = true;
      } else if (same) {
        at = i;
      }
    });
    if (clash) return { error: 'taken' };
    if (at < 0 && list.length >= SAVED.max) return { error: 'full' };
 
    var old = at > -1 ? list[at] : null;
    var item = {
      id:    old ? old.id : 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      name:  name,
      foot:  foot,
      fit:   FITS[p.fit] ? p.fit : 'comfort',
      socks: !!p.socks,
      /* the reminder counts from the last time the length changed,
         not from a rename */
      t:     old && old.foot === foot ? old.t : Date.now()
    };
    if (old) list[at] = item; else list.push(item);
    if (!writeSizes(list)) return { error: 'storage' };
    track('ks_size_saved', { foot_cm: foot, fit: item.fit, saved_count: list.length, updated: !!old });
    return { item: item, updated: !!old };
  }
 
  function removeSize(id) {
    var list = readSizes();
    var left = list.filter(function (p) { return p.id !== id; });
    if (left.length === list.length) return false;
    if (pick() === id) pick(null);
    track('ks_size_deleted', { saved_count: left.length });
    return writeSizes(left);
  }
 
  /* Who they are shopping for in this visit. Lives in sessionStorage,
     so it ends when the tab is closed. */
  function pick(id) {
    try {
      if (id === undefined) return sessionStorage.getItem(PICK) || '';
      if (id) sessionStorage.setItem(PICK, id); else sessionStorage.removeItem(PICK);
    } catch (e) {}
    return id || '';
  }
 
  function monthsSince(p) {
    return Math.max(0, Math.floor((Date.now() - (+p.t || Date.now())) / 2629800000));
  }
  function isStale(p) {
    if (!SAVED.remind || !p) return false;
    if (SAVED.who !== 'all' && p.fit !== 'grow') return false;
    return monthsSince(p) >= SAVED.remind;
  }
 
  /* ---------- Catalogue: every model, on demand ----------
     For the Kick Dock, Shop by size and the size guide: the models of a
     collection as a small JSON list from
       /collections/<handle>?view=ks-data   (templates/collection.ks-data.liquid)
     about 20 kB for the whole shop, where /products.json is about 1.9 MB.
     Built with build() above, so every widget matches models to charts
     exactly as the size finder does. Kept 10 minutes in this tab.
     catalog(handle, done) -> done([{ m: built model, r: raw, i: order }])
     catalogNow(handle)    -> the same list if it is already here, else null */
  var CAT_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (CAT_ROOT.charAt(CAT_ROOT.length - 1) !== '/') CAT_ROOT += '/';
  var CATS = {};
  function catBuild(raws) {
    var out = [];
    (raws || []).forEach(function (r, i) {
      var m = null;
      try { m = build(r); } catch (e) { m = null; }
      if (m) out.push({ m: m, r: r, i: i });
    });
    return out;
  }
  function catalogNow(handle) {
    var c = CATS[handle || 'all'];
    return c && c.d ? c.d : null;
  }
  function catalog(handle, done) {
    handle = handle || 'all';
    done = done || function () {};
    var c = CATS[handle];
    if (c && c.d) { done(c.d); return; }
    if (c) { c.w.push(done); return; }
    var url = CAT_ROOT + 'collections/' + encodeURIComponent(handle) + '?view=ks-data';
    var key = 'ks_cat_v1:' + url, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { cached = null; }
    if (cached && cached.d && cached.t > Date.now() - 600000) {
      CATS[handle] = { d: catBuild(cached.d), w: [] };
      done(CATS[handle].d);
      return;
    }
    CATS[handle] = { d: null, w: [done] };
    function finish(raws) {
      var cc = CATS[handle];
      cc.d = catBuild(raws);
      var w = cc.w; cc.w = [];
      w.forEach(function (f) { try { f(cc.d); } catch (e) {} });
    }
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { j = null; }
        var raws = j && j.products ? j.products : [];
        if (raws.length) { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: raws })); } catch (e) {} }
        finish(raws);
      })
      .catch(function () { finish([]); });
  }

  window.KSFinder = {
    catalog:    catalog,
    catalogNow: catalogNow,
    charts:   CHARTS,
    captions: CAPTIONS,
    products: PRODUCTS,
    fits:     FITS,
    minRoom:  MIN_ROOM,
    maxRoom:  MAX_ROOM,
    sockCm:   SOCK_CM,
    sizeFor:   sizeFor,
    findAll:   findAll,
    coverage:  coverage,
    colorList: colorList,
    brandList:  brandList,
    brandSizes: brandSizes,
    brandToCm:  brandToCm,
    brandEu:    brandEu,
    brandSizeLabel: brandSizeLabel,
    brandName:  brandName,
    genderName: genderName,
    toCm:     toCm,
    scoreOf:  score,
    remember: remember,
    recall:   recall,
    track:    track,
    analytics: analytics,
    build:    build,
    sizes: {
      on:      SAVED.on,
      max:     SAVED.max,
      names:   SAVED.names,
      remind:  SAVED.remind,
      t:       SAVED.t,
      list:    readSizes,
      get:     getSize,
      byName:  byName,
      match:   matchSize,
      save:    saveSize,
      remove:  removeSize,
      pick:    pick,
      months:  monthsSince,
      stale:   isStale,
      clean:   cleanName
    }
  };
})();
